/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable no-else-return */
/* eslint-disable no-empty */
/* eslint-disable no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import loader from '../images/loading.gif';
import {
  MainContainer,
} from './StyledComponents';
import formatDate from '../services/formatDate';
import getScheduleTardies from '../services/getScheduleTardies';
import getTardiesDetentions from '../services/getTardiesDetentions';

export default class StudentSchedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      schedule: [],
      loading: true,
      pendingDetentions: 0,
      c: 1,
    };
    this.getActiveTabBody = this.getActiveTabBody.bind(this);
  }

  componentDidMount() {
    //  to remove fluctuation of button
    setInterval(() => {
      const a = document.getElementsByClassName('sche-menu-body');
      if (a && a.length) {
        const b = a[0];
        if (window.screen.availHeight - 183 < b.scrollHeight) {
          this.setState({ c: 0 });
        }
      }
    }, 0);

    const studentDetails = JSON.parse(localStorage.getItem('studentDetails'));
    if (studentDetails) {
      //  to remove lagging in schedule view - handled with localstorage
      let data = [];
      data = JSON.parse(localStorage.getItem('scheduleData'));
      let detention = [];
      detention = JSON.parse(localStorage.getItem('totalDetentions'));
      if (data) {
        this.setState({ schedule: data, loading: false, pendingDetentions: detention });
      }

      getScheduleTardies(studentDetails.school_code,
        studentDetails.student_no,
        studentDetails.student_id)
        .then((res) => res.json())
        .then((res) => {
          // this.setState({ schedule: res.data });
          const updatedSche = res.data;
          // comparing two objects
          const result = _.isEqual(updatedSche, data);
          if (result === false) {
          //  new data available
             // console.log('updated');
            this.setState({ schedule: updatedSche, loading: false });
            localStorage.setItem('scheduleData', JSON.stringify(updatedSche));
          }
          // this.setState({schedule: JSON.parse(localStorage.getItem('scheduleData'))})
          const date = new Date();
          const formattedDate = formatDate(date);
          const detentionTime = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} at ${formattedDate[0]}:${formattedDate[1]} ${(formattedDate[2]).split(' ')[1]}`;
          localStorage.setItem('scheduleCacheTime', JSON.stringify(detentionTime));
        })
        .catch(() => {
          const res = JSON.parse(localStorage.getItem('scheduleData'));
          this.setState({ schedule: res || [] });
        });

      getTardiesDetentions(studentDetails.school_code,
        studentDetails.student_no,
        studentDetails.student_id)
        .then((res) => res.json())
        .then((res) => {
          localStorage.setItem('totalDetentions', JSON.stringify(res.data.totalDetentionOfStudent));
          if (res.data) {
            this.setState({ pendingDetentions: JSON.parse(localStorage.getItem('totalDetentions')), loading: false });
          }
        })
        .catch((error) => {
           // console.log(error);
          this.setState({ pendingDetentions: 0, loading: false });
        });
    } else {
      const { history } = this.props;
      history.replace('/');
    }
  }

  getActiveTabBody(activeTab) {
    const { schedule, error, loading } = this.state;
    let val = null;
    let scheduleView = [];
    if (activeTab === 0) {
      if (loading) {
        return (
          <img className="menu-loader" src={loader} alt="Loading ..." />
        );
      } else if (schedule && schedule.length > 0) {
        schedule.forEach((element, i) => {
          scheduleView.push(
            // eslint-disable-next-line react/no-array-index-key
            <div className="tardy-list sche-list" key={i}>
              <div className="sche-period">
                {element.period}
              </div>
              <div className="sche-details-wrapper">
                <div className="sche-name-wrapper">
                  <div className="sche-course-name">{element.course_name}</div>
                  <div className="sche-tech-name">{element.teacher_name}</div>
                  <div className="sche-tech-room">{element.room}</div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <div
                    className="sche-tardi"
                    onClick={() => {
                      const period = `${element.period}`;
                      const step1 = period.split('');
                      step1.shift();
                      const step2 = step1.join('');
                      // eslint-disable-next-line radix
                      if (parseInt(element.TotalTardy) === 0) {
                        return;
                      }
                      const { history } = this.props;
                      history.push(`/tardies/${step2}`);
                    }}
                    role="link"
                  >
                    <p className="sche-tardi-count">
                      {element.TotalTardy}
                    </p>
                    <p className="sche-tar">Tardies</p>
                  </div>
                </div>
              </div>
            </div>,
          );
        });
      } else {
        scheduleView = <p>Nothing to show here!</p>;
      }
    }
    if (activeTab === 0) {
      val = (
        <div>
          {error && (
            <div className="offline-banner">
              {error}
            </div>
          )}
          {scheduleView}
        </div>
      );
    }
    return val;
  }

  render() {
    const { pendingDetentions, loading } = this.state;
    if (loading) {
      return (
        <img className="menu-loader" src={loader} alt="Loading ..." />
      );
    }
    return (
      <MainContainer className="student-detail-page">
        <div
          className="menu"
          style={{
            zIndex: 19, position: 'absolute', backgroundColor: 'white', width: '100%', height: '100%',
          }}
        >

          <div className="sche-menu-wrapper">
            <div
              className="sche-menu-header-wrapper"
              style={{
                display: 'flex', justifyContent: 'center', height: 120, borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px',
              }}
            >
              <div className="sche-menu-header">
                <p style={{ fontSize: '21px' }}><b>Schedule</b></p>
                <p
                  style={{ fontSize: '19px' }}
                  onClick={() => {
                    const { history } = this.props;
                    history.replace('/detentions');
                  }}
                >
                  Pending Detentions
                </p>
                <p
                  style={{ fontSize: '21px', marginTop: '-5px' }}
                  onClick={() => {
                    const { history } = this.props;
                    history.replace('/detentions');
                  }}
                >
                  <b>{pendingDetentions}</b>
                </p>
              </div>
            </div>
            <div className="sche-menu-body">
              {this.getActiveTabBody(0)}
            </div>
            <div
              className={this.state.c === 1 ? 'back-btn non-float' : 'back-btn'}
              style={this.state.c === 1 ? { left: (window.screen.width * 0.27) } : null}
              onClick={() => {
                const { history } = this.props;
                history.replace('/studentDetails');
              }}
              role="button"
            >
              <p> &lt; Back</p>
            </div>
          </div>

        </div>
      </MainContainer>
    );
  }
}

StudentSchedule.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
};
